import { AlertTriangle } from "lucide-react";
import { fmtDateLong } from "./calendarUtils";

export function ConflictsPanel({ conflicts, onOpen }) {
  if (!conflicts?.length) return null;
  return (
    <div className="border border-red-500/40 bg-red-500/5 p-4 mb-6" data-testid="conflicts-panel">
      <h3 className="flex items-center gap-2 text-red-300 font-semibold mb-1"><AlertTriangle className="w-4 h-4" />Konflikte zur Prüfung</h3>
      <p className="text-xs text-[#A1A1AA] mb-3">Diese bestehenden Buchungen verstoßen gegen die aktuellen Buchungsregeln. Sie wurden nicht automatisch verändert – bitte prüfen, verschieben oder absagen.</p>
      <div className="space-y-2">
        {conflicts.map((c) => (
          <button type="button" key={c.appointment_id} onClick={() => onOpen(c.appointment_id)} className="w-full text-left bg-[#121212] border border-white/5 hover:border-red-400/50 p-3 text-sm flex flex-wrap gap-x-4 gap-y-1" data-testid={`conflict-${c.appointment_id}`}>
            <span className="text-white font-medium">{fmtDateLong(c.date)}, {c.time} Uhr</span>
            <span className="text-[#A1A1AA]">{c.customer_name} · {c.training_name}</span>
            <span className="text-red-300 w-full">{c.reason}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
